import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
  ScreenSizeConfiguration,
} from "../../../utils/configurationProvider";
import AmountToWords from "../../../components/_utils/AmountToWords";
import {
  getAllCategories,
  uploadFile,
} from "../../../redux/features/sharedResources/sharedResources";
import Validation from "../../../utils/validation";
import SVGComponent from "../../../components/_utils/SVGComponent";
import ICONS from "../../../assets/Icons";
import PrimaryStepper from "../../../components/_utils/CommonSteppers/PrimaryStepper";
import FieldForceCreateTxnSelectAccount from "../../../components/FieldForceTransactionComp/FieldForceCreateTxnSelectAccount";
import FieldForceCreateTxnAdditionalDetails from "../../../components/FieldForceTransactionComp/FieldForceCreateTxnAdditionalDetails";
import FieldForceTransferAmount from "../../../components/FieldForceTransactionComp/FieldForceCreateTxnTransferAmount";
import FieldForceTxnConfirm from "../../../components/FieldForceTransactionComp/FieldForceTxnConfirm";
import {
  fieldForceTxnRequest,
  fieldForceTxnRequestApproval,
  getAllfieldForceTxn,
} from "../../../redux/features/fieldForceTransaction";
import CommonToast from "../../../components/_utils/CommonToast";
import { toast } from "react-toastify";
import CommonAlertCard from "../../../components/_utils/CommonAlertCard/index.jsx";
import SmallPopupWithBulletPoints from "../../../components/_utils/CommonSmallPopupWithBulletPoint/index.jsx";
import {
  getOutsideBankingHoursLabel,
  isOutsideBankingHours,
} from "../../../utils/bankingHours.js";
import SmallPopup from "../../../components/_utils/CommonSmallPopup/index.jsx";
import globalText from "../../../utils/globalText.js";

const FieldForceCreateTxn = () => {
  const refactoredTxn = JSON.parse(sessionStorage.getItem("recreate_ben"));

  const steps = [
    "Source and destination account",
    "Category and labels",
    "Amount",
    "Confirm and create",
  ];

  const scrollIt = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  // const currentAccountDetails = location?.state;

  const FF_TXN_SESSION_KEY = "ff_create_txn_session_data";

  if (location?.state) {
    sessionStorage.setItem(FF_TXN_SESSION_KEY, JSON.stringify(location.state));
  }

  let currentAccountDetails = null;
  try {
    const savedData = sessionStorage.getItem(FF_TXN_SESSION_KEY);
    currentAccountDetails = savedData ? JSON.parse(savedData) : null;
  } catch (e) {
    currentAccountDetails = null;
  }

  // const type = location?.state?.type;
  // const flow = location?.state?.flow;
  // const TypeRTGS = location?.state?.TypeRTGS;

  const type = currentAccountDetails?.type;
  const flow = currentAccountDetails?.flow;
  const TypeRTGS = currentAccountDetails?.TypeRTGS;

  const [createActive, setCreateActive] = useState(false);
  const [showConfirmLeavePopup, setShowConfirmLeavePopup] = useState(false);
  const [files, setFiles] = useState([]);
  const [endDate, setEndDate] = useState({});

  const [isNeft, setIsNeft] = useState(
    currentAccountDetails?.requested_amount <
      GlobalConfiguration?.settleTypeValue
      ? true
      : false,
  );
  const [isRtgs, setIsRtgs] = useState(
    currentAccountDetails?.requested_amount >
      GlobalConfiguration?.settleTypeValue
      ? true
      : false,
  );
  const [isImps, setIsImps] = useState(false);
  const [quantity, setQuantity] = useState({});
  const [timeData, setTimeData] = useState({});
  const [catShow, setCatShow] = useState(false);
  const [startDate, setStartDate] = useState({});
  const [mapingCat, setMapingCat] = useState("");
  const [activeStep, setActiveStep] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const [refactor, setRefactor] = useState(false);
  const [showImages, setShowImages] = useState("");
  const [hyperLinks, setHyperLinks] = useState({});
  const [mapingData, setMapingData] = useState("");
  const [quantities, setQuantities] = useState({});
  const [refreshId, setRefreshId] = useState(true);
  const [labelsAcc, setLabelsAcc] = useState(null);
  const [direction, setDirection] = useState(null);
  const [isMounted, setIsMounted] = useState(true);
  const [catSelect, setCatSelect] = useState(false);
  const [openOwner, setOpenOwner] = useState(false);
  const [paymentBox, setpaymentBox] = useState(false);
  const [selectBank, setSelectBank] = useState(false);
  const [startDateCal, setStartDateCal] = useState({});
  const [showYearDrop, setShowYearDrop] = useState({});
  const [smallSearch, setSmallSearch] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [amountInWords, setAmountInWords] = useState("");
  const [selectedValue, setSelectedValue] = useState({});
  const [RefactorFlow, setRefactorFlow] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState({});
  const [additionalData, setAdditionalData] = useState({});
  const [refactiorFlow, setRefactiorFlow] = useState(true);
  const [accountSelect, setAccountSelect] = useState(false);
  const [selectSortAmt, setSelectSortAmt] = useState(false);
  const [refactorTxnData, setRefactorTxnData] = useState([]);
  const [isConfidential, setIsConfidential] = useState(false);
  const [removeClassName, setRemoveClassName] = useState(true);
  const [showRupeeSymbol, setShowRupeeSymbol] = useState(false);
  const [isButtonDisabled, setButtonDisabled] = useState(false);
  const [showDatePickerCal, setShowDatePickerCal] = useState({});
  const [selectedCategory, setSelectedCategory] = useState(
    currentAccountDetails?.selectedCategory ?? null,
  );
  const [dateRangeEnabled, setDateRangeEnabled] = useState(false);

  const [nextButtonEnabled, BenEnableNextButton] = useState(true);
  const [selectedValueMonth, setSelectedValueMonth] = useState({});
  const [accountModalSearch, setAccountModalSearch] = useState(false);
  const [associateModalOpen, setAssociateModalOpen] = useState(false);
  const [isConnectedSelected, setIsConnectedSelected] = useState(true);
  const [selectBankNonActive, setSelectBankNonActive] = useState(false);
  const [transactionFilterData, setTransactionFilterData] = useState([]);
  const [isSingleDateSelected, setIsSingleDateSelected] = useState(false);
  const [smallSearchNonActive, setSmallSearchNonActive] = useState(false);
  const [refactorPaymentMethod, setRefactorPaymentMethod] = useState(false);
  const [selectedValueName, setselectedValueName] = useState("username" || "");
  const [initialRefactorAdditionalDetail, setInitialRefactorAdditionalDetail] =
    useState({});
  const [txnLoading, settxnLoading] = useState(false);
  const [showSimilarModal, setShowSimilarModal] = useState(false);
  const [similarTransaction, setSimilarTransaction] = useState(false);
  const [showBankingHoursPopup, setShowBankingHoursPopup] = useState(false);

  const [refactorConfidentailDetail, setRefactorConfidentailDetail] =
    useState(false);
  const [copyData, setCopyData] = useState({
    title: "",
    data_type: "",
    value: "",
  });

  const [filterPayload, setFilterPayload] = useState({
    pagination: GlobalConfiguration?.lengthCheckZero,
    accNoInput: "",
    currentPage: GlobalConfiguration?.lengthCheckOne,
    sortBank: "",
    sortAccountNo: "",
    bankNameInput: "",
    currentPageText: "01",
    beneAccountSearch: "",
    searchTerm: "",
  });
  const [filterPayloadNonActive, setFilterPayloadNonActive] = useState({
    pagination: GlobalConfiguration?.lengthCheckZero,
    accNoInput: "",
    currentPage: GlobalConfiguration?.lengthCheckOne,
    sortBank: "",
    sortAccountNo: "",
    bankNameInput: "",
    currentPageText: "01",
    searchTerm: "",
  });

  const [txnPayLoad, setTxnPayLoad] = useState({
    bankAccountName: currentAccountDetails?.bankAccountName
      ? currentAccountDetails?.bankAccountName
      : "",
    beneAccountId: currentAccountDetails?.beneAccountId
      ? currentAccountDetails?.beneAccountId
      : "",
    bankAccountIFSC: currentAccountDetails?.bankAccountIFSC
      ? currentAccountDetails?.bankAccountIFSC
      : "",
    bankAccountNo: currentAccountDetails?.bankAccountNo
      ? currentAccountDetails?.bankAccountNo
      : "",
    categories: currentAccountDetails?.categories
      ? currentAccountDetails?.categories
      : "",
    categoryId: currentAccountDetails?.categoryId || "",
    amount: currentAccountDetails?.requested_amount,
    settleType: currentAccountDetails?.requested_amount
      ? Number(currentAccountDetails?.amount) >
        Number(GlobalConfiguration?.settleTypeValue)
        ? "rtgs"
        : "neft"
      : "",
    bankLogo: currentAccountDetails?.bankLogo
      ? currentAccountDetails?.bankLogo
      : "",
    pan: currentAccountDetails?.pan ? currentAccountDetails?.pan : "",
    ownerId: null,
    ownerAccountName: "",
    ownerBankIFSC: null,
    ownerBankBalance: GlobalConfiguration?.lengthCheckZero,
    ownerBankLogo: null,
    ownerLastUpdated: null,
    ownerBankAccountNo: null,
    selectedCategory: currentAccountDetails?.selectedCategory ?? null,
    mergeCategory: currentAccountDetails?.mergeCategory ?? null,
    amountInWords: currentAccountDetails?.amountInWords ?? "",
    labels: currentAccountDetails?.labels ? currentAccountDetails?.labels : [],
    ownerLabels: [],
    comment: "",
    date: currentAccountDetails?.date
      ? new Date(currentAccountDetails?.date)
      : "",
    expenseType: currentAccountDetails?.expenseType ?? "",
    description: currentAccountDetails?.description ?? "",
    uploadFile: currentAccountDetails?.uploadFile ?? "",
    uploadURL: currentAccountDetails?.uploadURL,
  });
  const [NewAmount, setNewAmount] = useState(
    currentAccountDetails?.requested_amount || "",
  );
  const [category, setCategory] = useState(
    txnPayLoad?.categories ? txnPayLoad?.categories?.split(",") : [],
  );
  const [AmountDisable, setAmountDisable] = useState(false);
  const [openBar, setOpenBar] = useState(false);
  const [openBarHeight, setOpenBarHeight] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );

  const initialAmount = Number(
    currentAccountDetails?.requested_amount ||
      GlobalConfiguration?.lengthCheckZero,
  );
  const enteredAmount = Number(
    txnPayLoad?.amount || GlobalConfiguration?.lengthCheckZero,
  );

  const isStepValidRequest = !currentAccountDetails?.requested_amount
    ? true
    : enteredAmount <= initialAmount;

  const formatDate = (date) => {
    return `${date.getDate()}/${date.getMonth() < GlobalConfiguration?.panLength ? `0${date.getMonth() + GlobalConfiguration.lengthCheckOne}` : date.getMonth() + GlobalConfiguration.lengthCheckOne}/${date.getFullYear()}`;
  };

  const animationClass =
    direction === "next" ? "animate-slide-next" : "animate-slide-prev";

  const getAmountInWords = (amount) => {
    const numericValue = amount?.replace(/[^0-9.]/g, "") || "";
    const amountNumber = parseFloat(numericValue);

    if (numericValue.trim() === "" || isNaN(amountNumber)) return "";

    const words = AmountToWords(amountNumber);
    return amountNumber > GlobalConfiguration?.lengthCheckZero &&
      amountNumber <= GlobalConfiguration?.lengthCheckOne
      ? words.replace("rupees", "rupee")
      : words;
  };
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > ScreenSizeConfiguration?.mobileScreen) {
        setRefactorFlow(false);
      }
    };
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    dispatch(getAllCategories());

    if (currentAccountDetails) {
      const previousUploadedFiles = {};
      const previousPreviewImages = {};

      const previousAdd =
        currentAccountDetails?.selectedCategory?.configuration?.data?.reduce(
          (acc, val) => {
            if (
              val?.data_type === "upload" &&
              val?.value &&
              !val?.value?.name
            ) {
              acc[val?.name] = {
                ...val?.value,
                name: val?.value?.metadata?.filename,
                type: val?.value?.metadata?.mime_type,
                size: val?.value?.metadata?.size,
              };
            } else {
              acc[val?.name] = val?.value;
            }
            return acc;
          },
          {},
        );

      setAdditionalData(previousAdd);

      currentAccountDetails?.selectedCategory?.configuration?.data?.forEach(
        (val) => {
          if (val?.data_type === "upload" && val?.value) {
            const key = `${val?.name}_${val?.data_type}`;
            const serverFile = val?.value;

            previousUploadedFiles[key] = {
              ...serverFile,
              name: serverFile?.metadata?.filename,
              size: serverFile?.metadata?.size,
            };

            previousPreviewImages[key] = {
              isServerFile: true,
              filename: serverFile?.metadata?.filename,
              mimeType: serverFile?.metadata?.mime_type,
              id: serverFile?.id,
            };
          }
        },
      );

      if (Object.keys(previousUploadedFiles).length > 0) {
        setUploadedFiles(previousUploadedFiles);
      }

      if (Object.keys(previousPreviewImages).length > 0) {
        setPreviewImages(previousPreviewImages);
      }
    }
  }, []);

  useEffect(() => {
    const dateUpdates = {};

    currentAccountDetails?.mergeCategory
      ?.filter((val) => val?.data_type === "date")
      ?.forEach((val) => {
        if (!val?.value) return;

        const parsedDate = new Date(val.value);
        if (isNaN(parsedDate.getTime())) return;

        dateUpdates[`${val?.name}_${val?.data_type}`] = parsedDate;
      });

    if (Object.keys(dateUpdates).length > 0) {
      setStartDate((prev) => ({ ...prev, ...dateUpdates }));
    }
  }, []);

  const handleKeyDown = useCallback((event) => {
    if (
      event.target.tagName !== "INPUT" &&
      event.target.tagName !== "TEXTAREA" &&
      (event.key === "ArrowLeft" || event.key === "ArrowRight")
    ) {
      event.preventDefault();
    }
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  const categories = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  );

  const { beneTxnAccountData, beneTxnAccountLoading } = useSelector(
    (state) => state?.beneTxnViewAccData,
  );

  // Can be use later
  // useEffect(() => {
  //   if (refactoredTxn?.txn_id) {
  //     dispatch(beneTxnAccountDetail(refactoredTxn?.txn_id));
  //   }
  // }, []);

  const isAmountValid =
    txnPayLoad?.amount > GlobalConfiguration?.lengthCheckZero;

  const isRtgsSelected =
    type === "PayFieldForceTxn"
      ? txnPayLoad?.amount > GlobalConfiguration?.settleTypeValue
      : txnPayLoad?.settleType === "rtgs";

  const isSettleTypeValid =
    txnPayLoad?.settleType &&
    !(
      (txnPayLoad?.settleType === "imps" &&
        txnPayLoad?.amount > GlobalConfiguration?.settleTypeValue) ||
      (txnPayLoad?.settleType === "rtgs" &&
        txnPayLoad?.amount <= GlobalConfiguration?.settleTypeValue) ||
      (txnPayLoad?.settleType === "neft" &&
        txnPayLoad?.amount > GlobalConfiguration?.settleTypeValue)
    );

  let isStepValid = false;

  const commentLength = (txnPayLoad?.comment ?? "").trim().length;
  const isCommentValid =
    commentLength === GlobalConfiguration?.lengthCheckZero ||
    commentLength >= GlobalConfiguration?.lengthCheckThree;

  const isRtgsValid =
    !isRtgsSelected ||
    txnPayLoad?.amount >= GlobalConfiguration?.settleTypeValue;

  useEffect(() => {
    if (!beneTxnAccountLoading) {
      const initalData = {};

      const additionalData =
        beneTxnAccountData?.transaction?.[0]?.additional_data?.data || [];

      additionalData?.forEach(({ name, value, data_type }) => {
        if (
          value !== null &&
          value !== "" &&
          value !== undefined &&
          value?.length !== GlobalConfiguration?.lengthCheckZero
        ) {
          if (
            data_type === "hyperlink" ||
            data_type === "string" ||
            data_type === "numeric"
          ) {
            initalData[name] = {
              isCopyClick: false,
              isPaste: {},
              name: name,
              data: value,
            };
          } else {
            initalData[name] = {
              isCopyDirect: false,
              name: name,
              data: value,
            };
          }
        }
      });
      setInitialRefactorAdditionalDetail(initalData);
      if (
        beneTxnAccountData?.transaction[0]?.confidential_transaction === "N"
      ) {
        setRefactorConfidentailDetail(true);
      }
      setRefactorTxnData(beneTxnAccountData?.transaction[0]);
      if (beneTxnAccountData?.transaction[0]?.payment_method === "NEFT") {
        setRefactorPaymentMethod(true);
      }
    }
  }, [beneTxnAccountData, beneTxnAccountLoading, refactor]);

  const handleCreateTransaction = async () => {
    try {
      setCreateActive(true);

      let haveImage = txnPayLoad?.mergeCategory?.some(
        (val) =>
          val?.data_type === "upload" &&
          val?.value !== "Not Given" &&
          uploadedFiles[val?.name],
      );

      let storeData;
      let add = GlobalConfiguration?.lengthCheckZero;
      let fileUpload;
      if (type !== "PayFieldForceTxn") {
        fileUpload = await dispatch(uploadFile(txnPayLoad?.uploadFile));
      }

      if (haveImage) {
        const responseUpload = await Promise.all(
          Object.values(uploadedFiles)?.map((file) =>
            dispatch(uploadFile(file)),
          ),
        );

        storeData = selectedCategory?.configuration?.data?.map((val) => {
          if (additionalData[val?.name]) {
            const dataValue = additionalData[val?.name];

            if (val?.data_type === "numeric") {
              const integerValue = parseInt(
                dataValue,
                GlobalConfiguration?.searchHeight,
              );
              if (isNaN(integerValue)) {
                throw new Error(
                  `Value '${dataValue}' is not a valid integer for '${val?.name}'`,
                );
              }
              return { ...val, value: integerValue };
            }

            if (val?.data_type === "upload") {
              const { description, ...rest } = val;
              return { ...rest, value: responseUpload[add++]?.payload };
            }

            if (val?.data_type === "toggle") {
              const { description, ...rest } = val;
              return { ...rest, value: dataValue };
            }

            return { ...val, value: dataValue };
          }

          if (val?.data_type === "toggle") {
            const { description, ...rest } = val;
            return { ...rest };
          }

          return val;
        });
      } else {
        storeData = selectedCategory?.configuration?.data?.map((val) => {
          if (additionalData?.[val?.name]) {
            const dataValue = additionalData[val?.name];

            if (val?.data_type === "numeric") {
              const integerValue = parseInt(
                dataValue,
                GlobalConfiguration?.searchHeight,
              );
              if (isNaN(integerValue)) {
                throw new Error(
                  `Value '${dataValue}' is not a valid integer for '${val?.name}'`,
                );
              }
              return { ...val, value: integerValue };
            }

            if (val?.data_type === "toggle") {
              const { description, ...rest } = val;
              return { ...rest, value: dataValue };
            }

            return { ...val, value: dataValue };
          }

          if (val?.data_type === "toggle") {
            const { description, ...rest } = val;
            return { ...rest };
          }

          return val;
        });
      }
      let response1;

      if (type !== "PayFieldForceTxn") {
        response1 = await dispatch(
          fieldForceTxnRequest({
            expense_type: txnPayLoad?.expenseType,
            amount: txnPayLoad?.amount,
            field_force_account_id: txnPayLoad?.beneAccountId,
            request_date: formatDate(new Date(txnPayLoad?.date)),
            uploaded_file_data: fileUpload?.payload,
            category_id: selectedCategory?.id,
            additional_data: storeData,
            labels: [
              ...(txnPayLoad?.labels || []),
              ...(txnPayLoad?.ownerLabels || []),
            ],
            description: txnPayLoad?.description,
            payment_method: txnPayLoad?.settleType?.toUpperCase(),
            comment: txnPayLoad?.comment,
          }),
        );

        if (response1?.error) {
          setCreateActive(false);
          navigate(
            "/field_force_transaction_dashboard/create_field_force_transaction/failed",
          );
          return;
        }
      }
      const response2 = await dispatch(
        fieldForceTxnRequestApproval({
          request_id:
            type === "PayFieldForceTxn"
              ? currentAccountDetails?.request_id
              : response1?.payload?.request?.[0]?.request_id,
          amount: txnPayLoad?.amount,
          owner_account_id: txnPayLoad?.ownerId,
          comments: txnPayLoad?.comment,
          payment_method: txnPayLoad?.settleType.toUpperCase(),
        }),
      );

      if (response2?.error?.message !== "Rejected") {
        const transactionId =
          type === "PayFieldForceTxn"
            ? currentAccountDetails?.request_id
            : response1?.payload?.request?.[0]?.request_id;

        sessionStorage.removeItem(FF_TXN_SESSION_KEY);

        navigate(
          `/field_force_transaction_dashboard/create_field_force_transaction/success/${transactionId}`,
          {
            replace: true,
            state: {
              type: type === "PayFieldForceTxn" ? "PayFieldForceTxn" : "",
              Request_id: currentAccountDetails?.request_id,
              Txn_id:
                response2?.payload?.requests?.[0]
                  ?.field_force_transactions_details
                  ?.field_force_transaction_id,
            },
          },
        );
      } else {
        navigate(
          "/field_force_transaction_dashboard/create_field_force_transaction/failed",
          {
            replace: true,
          },
        );
      }
    } catch (error) {
      navigate(
        "/field_force_transaction_dashboard/create_field_force_transaction/failed",
        {
          replace: true,
        },
      );
    } finally {
      setCreateActive(false);
    }
  };

  const queryParams = () => ({
    page_no: GlobalConfiguration?.lengthCheckOne,
    page_item_count: PaginationConfiguration?.paginationSmall,
    amount: txnPayLoad?.amount,
    payment_method: txnPayLoad?.settleType?.toUpperCase(),
    field_force_account_id: txnPayLoad?.beneAccountId,
    owner_account_id: txnPayLoad?.ownerId,
  });

  const handleNext = async () => {
    if (isButtonDisabled) return;
    setButtonDisabled(true);
    try {
      if (activeStep === GlobalConfiguration?.lengthCheckTwo) {
        settxnLoading(true);
        const res = await dispatch(getAllfieldForceTxn(queryParams()));
        const hasDuplicates =
          res?.payload?.transactions?.length >
          GlobalConfiguration?.lengthCheckZero;

        setSimilarTransaction(hasDuplicates);

        if (hasDuplicates) {
          toast?.dismiss();
          CommonToast({
            text: "Few issues found click check to view.",
            icon: ICONS?.INFO_FILLED,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        } else {
          toast?.dismiss();
          CommonToast({
            text: "No issues found.",
            icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }
        setActiveStep((prev) => prev + GlobalConfiguration?.lengthCheckOne);
        settxnLoading(true);
        setDirection("next");
        setRemoveClassName(false);
        setTimeout(() => {
          setRemoveClassName(true);
        }, IntervalConfiguration?.intervalSemiMid);

        setOpenBar(false);
      } else if (activeStep === GlobalConfiguration?.lengthCheckThree) {
        if (similarTransaction) {
          setShowSimilarModal(true);
        } else {
          await handleCreateTransaction();
        }
      } else {
        setActiveStep((prev) => prev + GlobalConfiguration?.lengthCheckOne);

        setDirection("next");

        setRemoveClassName(false);
        setTimeout(() => {
          setRemoveClassName(true);
        }, IntervalConfiguration?.intervalSemiMid);

        setTimeout(() => {
          setButtonDisabled(false);
        }, IntervalConfiguration?.intervalSmaller);
        setOpenBar(false);
      }
    } finally {
      setButtonDisabled(false);
    }
  };

  // Enter -> trigger the same forward action as the "Next"/"Create" stepper button.
  // Mirrors the account-create flows, but intentionally has NO Backspace-back handling.
  // Skips TEXTAREA targets so multi-line fields (e.g. comment) keep normal Enter/newline behavior.
  const handleEnterKeyPress = useCallback(
    (e) => {
      if (e.key !== "Enter") return;
      if (e.target.tagName === "TEXTAREA") return;

      e.preventDefault();
      e.stopPropagation();

      if (!nextButtonEnabled && !isButtonDisabled && !createActive) {
        handleNext();
      }
    },
    [nextButtonEnabled, isButtonDisabled, createActive, handleNext],
  );

  useEffect(() => {
    document.addEventListener("keydown", handleEnterKeyPress);
    return () => {
      document.removeEventListener("keydown", handleEnterKeyPress);
    };
  }, [handleEnterKeyPress]);

  const allowedValue = (value) => {
    return Validation?.allowedAmount(value);
  };

  const handleAmountChange = (data) => {
    const { name, value } = data;

    if (value[0] !== GlobalConfiguration?.lengthCheckZero) {
      const numericValue = value?.replace(/[^0-9.]/g, "");

      if (name === "amount") {
        if (
          allowedValue(numericValue) ||
          numericValue.length === GlobalConfiguration?.lengthCheckZero
        ) {
          const amountNumber = parseFloat(numericValue);
          const amountWords =
            numericValue?.trim() === "" ? "" : AmountToWords(amountNumber);

          const adjustedAmountWords =
            amountNumber >= GlobalConfiguration?.lengthCheckOne &&
            amountNumber <= GlobalConfiguration?.accountnormalLength
              ? amountWords?.replace("rupees", "rupee")
              : amountWords;

          setTxnPayLoad((prevState) => ({
            ...prevState,
            amount: numericValue,
            amountInWords: adjustedAmountWords,
          }));

          setShowRupeeSymbol(numericValue?.trim() !== "");
          setAmountInWords(adjustedAmountWords);
        }
      }
    }
  };

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled,
      stepperText: steps[GlobalConfiguration?.lengthCheckZero],
    },
    {
      previousText: "Previous",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled,
      stepperText: steps[GlobalConfiguration?.lengthCheckOne],
    },
    {
      previousText: "Previous",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled,
      stepperText: steps[GlobalConfiguration?.lengthCheckTwo],
    },
    {
      previousText: "Previous",
      nextText: similarTransaction ? "Check" : "Create",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: similarTransaction
        ? "var(--emphasis)"
        : "var(--positive-act)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--text-primary)",
      nextDisableBgColor: "var(--positive-act)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: createActive,
      nextLoaderNeeded: true,
      nextIsEnabled: !nextButtonEnabled && !createActive,
      stepperText: steps[GlobalConfiguration?.accountminLength],
    },
  ];

  const renderCreateTxn = () => {
    switch (activeStep) {
      case GlobalConfiguration?.lengthCheckZero:
        return (
          <FieldForceCreateTxnSelectAccount
            catName={beneTxnAccountData?.transaction?.[0]?.category}
            catShow={catShow}
            setCatShow={setCatShow}
            catSelect={catSelect}
            setCatSelect={setCatSelect}
            accountSelect={accountSelect}
            setAccountSelect={setAccountSelect}
            mapingData={mapingData}
            mapingCat={mapingCat}
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            handleCategorySelect={handleCategory}
            BenEnableNextButton={BenEnableNextButton}
            additionalData={additionalData}
            setAdditionalData={setAdditionalData}
            activeStep={activeStep}
            associateModalOpen={associateModalOpen}
            setAssociateModalOpen={setAssociateModalOpen}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            filterPayload={filterPayload}
            setFilterPayload={setFilterPayload}
            accountModalSearch={accountModalSearch}
            setAccountModalSearch={setAccountModalSearch}
            setSelectedValue={setSelectedValue}
            setSelectedValueMonth={setSelectedValueMonth}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            setShowDatePicker={setShowDatePicker}
            setDateRangeEnabled={setDateRangeEnabled}
            setShowDatePickerCal={setShowDatePickerCal}
            setStartDateCal={setStartDateCal}
            setIsSingleDateSelected={setIsSingleDateSelected}
            setQuantities={setQuantities}
            amountInWords={amountInWords}
            setAmountInWords={setAmountInWords}
            setFiles={setFiles}
            setShowImages={setShowImages}
            hyperLink={hyperLinks}
            setHyperLink={setHyperLinks}
            setPreviewImages={setPreviewImages}
            setUploadedFiles={setUploadedFiles}
            setTimeData={setTimeData}
            setMapingCat={setMapingCat}
            labelsAcc={labelsAcc}
            setLabelsAcc={setLabelsAcc}
            openOwner={openOwner}
            setOpenOwner={setOpenOwner}
            isConfidential={isConfidential}
            setIsConfidential={setIsConfidential}
            flow={flow === "PayFieldForceTxn" ? flow : "field_force"}
            type={type}
            TypeRTGS={TypeRTGS}
            currentAccountDetails={currentAccountDetails}
          />
        );
      case GlobalConfiguration?.lengthCheckOne:
        return (
          <FieldForceCreateTxnAdditionalDetails
            catShow={catShow}
            setCatShow={setCatShow}
            setSelectedCategory={setSelectedCategory}
            category={category}
            setCategory={setCategory}
            txnPayLoad={txnPayLoad}
            categories={categories}
            setTxnPayLoad={setTxnPayLoad}
            catName={beneTxnAccountData?.transaction?.[0]?.category}
            catSelect={catSelect}
            selectedCategory={selectedCategory}
            handleCategorySelect={handleCategory}
            setCatSelect={setCatSelect}
            additionalData={additionalData}
            setAdditionalData={setAdditionalData}
            mapingCat={mapingCat}
            setMapingCat={setMapingCat}
            BenEnableNextButton={BenEnableNextButton}
            nextButtonEnabled={nextButtonEnabled}
            activeStep={activeStep}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            selectedValueMonth={selectedValueMonth}
            setSelectedValueMonth={setSelectedValueMonth}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            showDatePicker={showDatePicker}
            setShowDatePicker={setShowDatePicker}
            dateRangeEnabled={dateRangeEnabled}
            setDateRangeEnabled={setDateRangeEnabled}
            showDatePickerCal={showDatePickerCal}
            setShowDatePickerCal={setShowDatePickerCal}
            startDateCal={startDateCal}
            setStartDateCal={setStartDateCal}
            isSingleDateSelected={isSingleDateSelected}
            setIsSingleDateSelected={setIsSingleDateSelected}
            quantities={quantities}
            setQuantities={setQuantities}
            files={files}
            setFiles={setFiles}
            amountInWords={amountInWords}
            setAmountInWords={setAmountInWords}
            showImages={showImages}
            setShowImages={setShowImages}
            hyperLink={hyperLinks}
            setHyperLink={setHyperLinks}
            showRupeeSymbol={showRupeeSymbol}
            setShowRupeeSymbol={setShowRupeeSymbol}
            uploadedFiles={uploadedFiles}
            setUploadedFiles={setUploadedFiles}
            previewImages={previewImages}
            setPreviewImages={setPreviewImages}
            timeData={timeData}
            setTimeData={setTimeData}
            copyData={copyData}
            setCopyData={setCopyData}
            handleAmountChange={handleAmountChange}
            initialRefactorAdditionalDetail={initialRefactorAdditionalDetail}
            setInitialRefactorAdditionalDetail={
              setInitialRefactorAdditionalDetail
            }
            setQuantity={setQuantity}
            quantity={quantity}
            setShowYearDrop={setShowYearDrop}
            showYearDrop={showYearDrop}
            type={type}
          />
        );
      case GlobalConfiguration?.lengthCheckTwo:
        return (
          <FieldForceTransferAmount
            selectBank={selectBank}
            setSelectBank={setSelectBank}
            filterPayload={filterPayload}
            setFilterPayload={setFilterPayload}
            filterPayloadNonActive={filterPayloadNonActive}
            setFilterPayloadNonActive={setFilterPayloadNonActive}
            smallSearch={smallSearch}
            setSmallSearch={setSmallSearch}
            selectSortAmt={selectSortAmt}
            setSelectSortAmt={setSelectSortAmt}
            isConnectedSelected={isConnectedSelected}
            setIsConnectedSelected={setIsConnectedSelected}
            BenEnableNextButton={BenEnableNextButton}
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            isNeft={isNeft}
            setIsNeft={setIsNeft}
            isRtgs={isRtgs}
            setIsRtgs={setIsRtgs}
            isImps={isImps}
            setIsImps={setIsImps}
            transactionFilterData={transactionFilterData}
            setTransactionFilterData={setTransactionFilterData}
            refreshId={refreshId}
            setRefreshId={setRefreshId}
            openOwner={openOwner}
            setOpenOwner={setOpenOwner}
            selectBankNonActive={selectBankNonActive}
            setSelectBankNonActive={setSelectBankNonActive}
            smallSearchNonActive={smallSearchNonActive}
            setSmallSearchNonActive={setSmallSearchNonActive}
            activeStep={activeStep}
            isConfidential={isConfidential}
            setIsConfidential={setIsConfidential}
            RefactorFlow={RefactorFlow}
            setRefactorFlow={setRefactorFlow}
            setpaymentBox={setpaymentBox}
            labelsAcc={labelsAcc}
            showRupeeSymbol={showRupeeSymbol}
            setShowRupeeSymbol={setShowRupeeSymbol}
            amountInWords={amountInWords}
            setAmountInWords={setAmountInWords}
            copyData={copyData}
            setCopyData={setCopyData}
            selectedValueName={selectedValueName}
            setselectedValueName={setselectedValueName}
            NewAmount={NewAmount}
            setNewAmount={setNewAmount}
            type={type}
            setAmountDisable={setAmountDisable}
            currentAccountDetails={currentAccountDetails}
            isStepValid={isStepValidRequest}
            RequestAmountWords={getAmountInWords}
            isRtgsValid={isRtgsValid}
            txnLoading={txnLoading}
          />
        );
      case GlobalConfiguration?.accountminLength:
        return (
          <FieldForceTxnConfirm
            txnPayLoad={txnPayLoad}
            requestedAmount={currentAccountDetails?.requested_amount}
            setTxnPayLoad={setTxnPayLoad}
            selectedCategory={selectedCategory}
            handleCategorySelect={handleCategory}
            categories={categories}
            additionalData={additionalData}
            amountInWords={txnPayLoad?.amountInWords}
            files={files}
            showImages={showImages}
            uploadedFiles={uploadedFiles}
            isConfidential={isConfidential}
            previewImages={previewImages}
            type="refactior"
            flow={flow}
            showSimilarModal={showSimilarModal}
            setShowSimilarModal={setShowSimilarModal}
            queryParams={queryParams()}
            onForceCreate={handleCreateTransaction}
          />
        );
      default:
        return null;
    }
  };

  const isValidHttpUrl = (url) => {
    const httpRegex =
      /^(https?:\/\/)([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(:[0-9]{1,5})?(\/.*)?$/;
    return httpRegex.test(url);
  };

  useEffect(() => {
    const configData = txnPayLoad?.selectedCategory?.configuration?.data || [];
    const mergeCategory = txnPayLoad?.mergeCategory || [];

    const mandatoryFields = configData.filter((val) => val?.mandatory === "Y");
    const filledMandatoryFields = mergeCategory.filter(
      (val) =>
        val?.mandatory === "Y" &&
        (val?.data_type === "from_year_to_year"
          ? val?.value?.from && val?.value?.to
          : val?.value),
    );

    const isMandatoryFieldsFilled =
      mandatoryFields?.length === filledMandatoryFields.length;

    const isHyperlinkHave = mergeCategory?.some(
      (val) => val?.data_type === "hyperlink",
    );

    const isHyperlinkvalid = mergeCategory
      ?.filter((val) => {
        return val?.data_type === "hyperlink" && val?.value !== "";
      })
      .every((val) => isValidHttpUrl(val?.value));

    const isHyperLink = isHyperlinkHave && isHyperlinkvalid;

    switch (activeStep) {
      // case 0:
      //   isStepValid =
      //     !!txnPayLoad?.ownerId &&
      //     !!txnPayLoad?.beneAccountId &&
      //     !!txnPayLoad?.selectedCategory;
      //   break;

      case 0:
        isStepValid = !!txnPayLoad?.ownerId && !!txnPayLoad?.beneAccountId;
        break;

      // case 1:
      //   isStepValid =
      //     (txnPayLoad?.date &&
      //       txnPayLoad?.expenseType?.length >=
      //         GlobalConfiguration?.accountminLength &&
      //       !Array.isArray(txnPayLoad?.uploadFile) &&
      //       txnPayLoad?.uploadFile &&
      //       isMandatoryFieldsFilled &&
      //       !isHyperlinkHave) ||
      //     isHyperLink;
      //   break;
      case 1:
        isStepValid =
          (isMandatoryFieldsFilled && !isHyperlinkHave) || isHyperLink;
        break;
      case 2:
        isStepValid = currentAccountDetails?.requested_amount
          ? Number(currentAccountDetails?.requested_amount) >=
              Number(txnPayLoad?.amount) &&
            isAmountValid &&
            isRtgsValid &&
            isSettleTypeValid &&
            isCommentValid
          : isAmountValid &&
            isRtgsValid &&
            isSettleTypeValid &&
            isCommentValid;
        break;

      case GlobalConfiguration?.accountminLength:
        isStepValid = true;
        break;

      default:
        isStepValid = true;
        break;
    }

    BenEnableNextButton(!isStepValid);
  }, [activeStep, txnPayLoad, hyperLinks]);

  const handleBack = () => {
    if (activeStep === GlobalConfiguration?.lengthCheckZero) {
      if (txnPayLoad?.ownerId) {
        setShowConfirmLeavePopup(true);
      } else {
        navigate(-1);
      }
      return;
    } else {
      setActiveStep((prevActiveStep) =>
        prevActiveStep
          ? prevActiveStep - GlobalConfiguration?.lengthCheckOne
          : GlobalConfiguration?.lengthCheckZero,
      );
      setDirection("previous");
      setRemoveClassName(false);
      settxnLoading(false);
      setTimeout(() => {
        setRemoveClassName(true);
      }, IntervalConfiguration?.intervalMedium);

      setOpenBar(false);
    }
  };

  // useEffect(() => {
  //   if (
  //     location?.state?.txnDetails?.reminderAmount !== "" &&
  //     txnPayLoad?.amount === "" &&
  //     location?.state !== null
  //   ) {
  //     let amountWords =
  //       AmountToWords(
  //         parseFloat(location?.state?.txnDetails?.reminderAmount),
  //       ) || "";
  //     setAmountInWords(
  //       location?.state?.txnDetails?.reminderAmount >=
  //         GlobalConfiguration?.lengthCheckOne &&
  //         location?.state?.txnDetails?.reminderAmount <=
  //           GlobalConfiguration?.accountnormalLength
  //         ? amountWords.replace("rupees", "rupee")
  //         : amountWords,
  //     );
  //     setTxnPayLoad((prev) => {
  //       return {
  //         ...prev,
  //         amount: location?.state?.txnDetails?.reminderAmount,
  //         amountInWords:
  //           location?.state?.txnDetails?.reminderAmount >=
  //             GlobalConfiguration?.lengthCheckZero &&
  //           location?.state?.txnDetails?.reminderAmount <=
  //             GlobalConfiguration?.accountnormalLength
  //             ? amountWords.replace("rupees", "rupee")
  //             : amountWords,
  //       };
  //     });
  //     setShowRupeeSymbol(true);
  //   }
  // }, [location]);

  useEffect(() => {
    if (
      currentAccountDetails?.txnDetails?.reminderAmount !== "" &&
      txnPayLoad?.amount === "" &&
      currentAccountDetails !== null
    ) {
      let amountWords =
        AmountToWords(
          parseFloat(currentAccountDetails?.txnDetails?.reminderAmount),
        ) || "";
      setAmountInWords(
        currentAccountDetails?.txnDetails?.reminderAmount >=
          GlobalConfiguration?.lengthCheckOne &&
          currentAccountDetails?.txnDetails?.reminderAmount <=
            GlobalConfiguration?.accountnormalLength
          ? amountWords.replace("rupees", "rupee")
          : amountWords,
      );
      setTxnPayLoad((prev) => {
        return {
          ...prev,
          amount: currentAccountDetails?.txnDetails?.reminderAmount,
          amountInWords:
            currentAccountDetails?.txnDetails?.reminderAmount >=
              GlobalConfiguration?.lengthCheckZero &&
            currentAccountDetails?.txnDetails?.reminderAmount <=
              GlobalConfiguration?.accountnormalLength
              ? amountWords.replace("rupees", "rupee")
              : amountWords,
        };
      });
      setShowRupeeSymbol(true);
    }
  }, [location]);

  const handleCategory = (selectedCategoryData) => {
    setSelectedCategory(selectedCategoryData);
  };

  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= ScreenSizeConfiguration.mobileScreen,
  );
  const [isStepper, setIsStepper] = useState(
    window.innerWidth <= ScreenSizeConfiguration.mobileScreen,
  );
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= ScreenSizeConfiguration.mobileScreen);
      setIsStepper(window.innerWidth <= ScreenSizeConfiguration.mobileScreen);
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);
  useEffect(() => {
    const container = document.querySelector(".reminder-flow-container");
    if (container) {
      setOpenBarHeight(container.getBoundingClientRect().height);
    }
  }, [openBar]);

  let operBarValidation = useCallback(() => {
    return (
      (!isModalOpen && activeStep == GlobalConfiguration.lengthCheckZero) ||
      (!openOwner && activeStep == GlobalConfiguration.lengthCheckTwo) ||
      activeStep == GlobalConfiguration.lengthCheckOne ||
      activeStep == GlobalConfiguration.accountminLength
    );
  }, [openOwner, isModalOpen, activeStep]);

  const [uploadedFiles, setUploadedFiles] = useState({});
  const [previewImages, setPreviewImages] = useState({});

  const isOutsideBankingHoursNow = isOutsideBankingHours();
  const shouldShowBankingHoursAlert =
    isOutsideBankingHoursNow &&
    [
      GlobalConfiguration.lengthCheckZero,
      GlobalConfiguration.lengthCheckThree,
    ].includes(activeStep);

  return (
    <>
      {showBankingHoursPopup && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop bg-opacity-dark-opacity justify-center z-z-index-modal">
          <SmallPopupWithBulletPoints
            headerTitle="Why transaction cannot be processed?"
            headerFontWeight="semibold"
            headerFontColor="negative-act"
            textSize="font-md"
            bulletPoints={[
              `Any transaction created or approved after banking hours i.e. between ${getOutsideBankingHoursLabel()} will be processed on the next bank working day.`,
              "Payments are time-critical (e.g., salary, vendor payment, or bill payment), consider the possible processing delay before proceeding.",
            ]}
            closeIconImage={ICONS?.CLOSE}
            closeModal={() => setShowBankingHoursPopup(false)}
          />
        </div>
      )}

      {showConfirmLeavePopup && (
        <div
          className="fixed z-z-index-max flex items-center justify-center top-top-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={(e) => e.stopPropagation()}
        >
          <SmallPopup
            headerTitle={globalText?.LEAVE_PAGE_WARNING_HEADER}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-lg"
            subtext={globalText?.EXIT_CURRENT_FLOW_NOTE}
            btnOneText={globalText?.STAY}
            btnOneHandleFunction={() => setShowConfirmLeavePopup(false)}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText={globalText?.LEAVE}
            btnTwoHandleFunction={() => {
              setShowConfirmLeavePopup(false);
              navigate(-1);
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoHoverOption="black"
          />
        </div>
      )}

      <div
        className="w-width-full flex justify-start items-center flex-col bg-primary-bg overflow-y-auto"
        style={{
          height:
            openOwner || isModalOpen || associateModalOpen
              ? "var(--height-full)"
              : "var(--full-height)",
        }}
      >
        <div className="w-width-full hidden Qsmd:block h-navbar-breadcrumb-height Qlg:bg-transparent bg-primary-nav flex-shrink-0"></div>
        <div className="bene_crt_reminder_header left-left-base z-z-index-loader flex justify-center items-center flex-col lg:flex-col-reverse w-width-full lg:py-padding-base bottom-bottom-base top-auto lg:top-top-base lg:bottom-auto bg-primary-nav-act Qsmd:bg-transparent rounded-border-radius-md">
          {isStepper && refactoredTxn?.type === "refactorFlow" && (
            <div className="fixed bottom-bottom-base w-width-full">
              <div
                style={{
                  display:
                    activeStep === GlobalConfiguration?.accountminLength
                      ? "none"
                      : "block",
                }}
                className="Refactor_responsive_Bottomdiv w-width-full bg-primary-nav-act p-padding-md relative global-hover-white z-z-index-base "
              >
                <div className="flex justify-between">
                  <p className="font-semibold text-text-primary text-font-xs">
                    Copy or autofill from previous transactions details
                  </p>
                  <div
                    className=" cursor-pointer"
                    onClick={() => {
                      setRefactorFlow(true);
                    }}
                  >
                    <img
                      src={ICONS?.ARROW_RIGHT_WHITE_CIRCLE}
                      alt="arrow_right"
                      className="w-icon-sm h-icon-sm"
                    />
                  </div>
                </div>
              </div>
              <div className="h-mobile-create-header w-width-full block Qmd:hidden"></div>
            </div>
          )}
          {
            // location?.state?.flowType === "ReminderFlow" &&
            currentAccountDetails?.flowType === "ReminderFlow" && (
              <div
                className={`${openBar && isStepper ? "none" : ""} stepper-Div w-width-full  Qsmd:hidden`}
                style={{
                  width: isMobile ? "var(--full-width)" : "",
                }}
              >
                <div className="reminder-flow-container bg-primary-card relative z-z-index-header rounded-br-border-radius-md rounded-bl-border-radius-md">
                  <div
                    className={`transition-[max-height] duration-animation-medium ease-in-out ${
                      openBar
                        ? "max-h-max-height-top-slider opacity-base-opacity pointer-events-auto"
                        : "max-h-0 opacity-opacity-none pointer-events-none "
                    } overflow-hidden`}
                    style={{
                      zIndex: openBar
                        ? "var(--z-index-content)"
                        : "var(--z-index-base)",
                    }}
                  >
                    <section className="reminder-flow-message-container">
                      <span className="text-font-xs text-text-primary font-sans Qsmd:hidden">
                        Reminder remark
                      </span>
                      <p
                        className={`text-font-xs text-text-primary font-sans font-normal pt-padding-sm Qsmd:pt-padding-base`}
                      >
                        {location?.state?.txnDetails?.reminderRemark}
                      </p>
                    </section>

                    <hr className="hidden w-max-content-width Qsmd:block border border-primary-bg" />
                  </div>

                  {openBar && (
                    <button
                      className="w-full h-auto flex items-center justify-center bg-text-primary cursor-pointer z-z-index-toast py-padding-sm fixed bottom-bottom-base left-left-base Qsmd:hidden transition-all duration-animation-medium ease-in-out"
                      onClick={() => setOpenBar(false)}
                    >
                      <span className="text-font-md font-sans font-semibold text-primary-card">
                        Back
                      </span>
                    </button>
                  )}

                  <section
                    className={`w-full Qmd:p-padding-sm p-padding-md  Qsmd:bg-primary-card flex flex-row Qsmd:justify-center Qmd:rounded-br-border-radius-md Qmd:rounded-bl-border-radius-md items-center gap-gap-sm bg-primary-nav-act justify-between z-z-index-base relative cursor-${
                      operBarValidation() ? "pointer" : ""
                    } hover:${operBarValidation() ? "bg-primary-card" : ""} ${
                      operBarValidation() ? "global-hover-white" : ""
                    }`}
                    onClick={() => {
                      if (operBarValidation()) {
                        setOpenBar(!openBar);
                      }
                    }}
                  >
                    <span className="text-font-xs text-text-primary font-sans font-normal">
                      Reminder remark
                    </span>

                    <div
                      className={`transition-transform duration-animation-medium ease-in-out `}
                    >
                      <SVGComponent
                        url={
                          isMobile
                            ? openBar
                              ? ICONS?.ARROW_UP_WHITE
                              : ICONS?.ARROW_RIGHT_WHITE
                            : openBar
                              ? ICONS?.ARROW_UP_WHITE
                              : ICONS?.ARROW_DOWN_WHITE
                        }
                        color="var(--text-primary)"
                        height={"var(--icon-sm)"}
                        width={"var(--icon-sm)"}
                      />
                    </div>
                  </section>
                </div>
              </div>
            )
          }

          <PrimaryStepper
            activeStep={activeStep}
            handleForwardAction={handleNext}
            handleBackwardAction={handleBack}
            dataArray={dataArray}
          />
        </div>
        {isStepper && (
          <>
            <div className="flex items-center w-full-width h-mobile-create-header bg-primary-nav p-padding-md top-top-base z-z-index-header shadow-box-shadow-bottom">
              <div
                className="cursor-pointer"
                onClick={() => {
                  if (openBar) {
                    setOpenBar(false);
                  } else if (
                    activeStep === GlobalConfiguration.lengthCheckZero
                  ) {
                    navigate("/field_force_transaction_dashboard");
                  } else {
                    navigate(-1);
                  }
                }}
              >
                <SVGComponent
                  url={ICONS?.ARROW_LEFT_WHITE}
                  color={"var(--text-primary)"}
                  height={"var(--icon-md)"}
                  width={"var(--icon-md)"}
                  alt="Arrow"
                />
              </div>
              <div className="flex flex-col ml-margin-md">
                <div className="text-text-primary text-base">
                  Field force transaction
                </div>

                {RefactorFlow ? (
                  <>
                    <p className="text-text-primary text-xs font-semibold">
                      Previous transaction details
                    </p>
                  </>
                ) : (
                  <>
                    <div className="text-text-secondary text-xs">
                      {steps[activeStep] || ""}
                    </div>
                  </>
                )}
              </div>
            </div>
          </>
        )}

        <div className="overflow-y-auto overflow-x-hidden w-width-full h-height-full">
          <div
            className={`max-w-tab-width-normal mx-auto scroll-smooth snap-x snap-mandatory w-width-full Qlg:w-max-content-width flex flex-col h-height-full Qsmd:pb-padding-base pb-padding-xl Qsmd:mb-margin-base mb-margin-md Qsmd:mt-margin-base Qsmd:pt-padding-base ${
              refactiorFlow ||
              (activeStep !== GlobalConfiguration?.lengthCheckOne &&
                activeStep !== GlobalConfiguration?.lengthCheckTwo &&
                activeStep !== GlobalConfiguration?.accountminLength)
                ? "pb-padding-xl"
                : ""
            }`}
            ref={scrollIt}
          >
            <>
              {shouldShowBankingHoursAlert && (
                <div className="max-w-tab-width-normal Qlg:mx-auto Qmd:pt-padding-lg  pt-padding-md Qlg:px-padding-base px-padding-md w-width-full">
                  <CommonAlertCard
                    title="Functioning outside banking hours"
                    texts="Transactions will be processed automatically during the next bank working day. Learn more"
                    highlightedText="Learn more"
                    onHighlightedTextClick={() =>
                      setShowBankingHoursPopup(true)
                    }
                  />
                </div>
              )}
              <div
                className={`w-width-full h-height-full mb-margin-md ${
                  activeStep === GlobalConfiguration?.lengthCheckZero &&
                  direction === "next"
                    ? ""
                    : removeClassName === true
                      ? ""
                      : animationClass
                }`}
              >
                {renderCreateTxn()}
              </div>
            </>
          </div>
        </div>
      </div>
    </>
  );
};

export default FieldForceCreateTxn;
